import React, { PropTypes } from 'react';
import { FlatButton, MenuItem, TextField, SelectField } from 'material-ui';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import GenericDialog from './generic-dialog';
import { isNil, isEmpty, not, either, equals, call, cond, T, complement, contains } from 'ramda';

const isNilOrEmpty = either(isNil, isEmpty);
const isNotNilOrEmpty = complement(isNilOrEmpty);
const notEqual = (first, second) => not(equals(first, second));

const fileLinkFields = [
  {
    leftLabel: 'File Name',
    prop: 'name',
  },
  {
    leftLabel: 'File URL',
    prop: 'url',
  },
  {
    leftLabel: 'File Type',
    prop: 'mediaType',
  },
];

const FileLink = props => {
  const {
    onCancel,
    clearState,
    state,
    submitFile,
    setState,
    onFileTypeCheckedSuccess,
    onFileTypeError,
    existingUrls,
    generateErrorText,
  } = props;

  return (
    <GenericDialog
      dialogTitle="Externally Hosted Image"
      actions={[
        <FlatButton
          label="Cancel"
          primary
          onTouchTap={() => {
            onCancel();
            clearState();
          }}
        />,
        <FlatButton
          label={!state.fileTypeChecked ? 'Validate File' : 'Submit'}
          secondary
          onTouchTap={() => {
            // FOR VIDEO LATER ON
            // const imageFile = state.fileType === 'image/jpeg';
            // const videoFile = state.fileType === 'video/mp4'; -- UNCOMMENT ONCE REACT IS UPDATED
            // if (imageFile) setState({ checkingFileType: true });
            // if (state.fileTypeChecked || notEqual(state.fileType, 'image/jpeg')) submitFile();
            setState({ checkingFileType: true });
            if (state.fileTypeChecked) submitFile();
          }}
          disabled={contains(state.url, existingUrls) || state.checkingFileType || state.fileTypeError || isNilOrEmpty(state.name) || isNilOrEmpty(state.url)}
        />,
      ]}
      mainContent={
        <div>
          {
            fileLinkFields.map((linkField, index) => {
              return (
                <div key={index}>
                  <TwoColumnRow
                    leftColumnClassName="Grid"
                    leftColumnContent={
                      <div className="Grid-cell Grid-cell--center">
                        {linkField.leftLabel}
                      </div>
                    }
                    leftColumnStyle={{ width: '25%', height: '34px' }}
                    rightColumnStyle={{ width: '70%' }}
                    rightColumnContent={
                      // {state.fileType} for value
                      equals(linkField.prop, 'mediaType') ?
                        <SelectField
                          style={{ width: '100%', marginTop: '-10px', overflow: 'hidden' }}
                          value="image/jpeg"
                          disabled
                          onChange={(event, i, value) => setState({
                            fileType: value,
                            fileTypeError: false,
                            fileTypeChecked: false,
                            checkingFileType: false,
                          })}
                          hintText="Select A File Type"
                        >
                          <MenuItem value={'image/jpeg'} primaryText="Image (.jpeg / .jpg / .png)"/>
                          {/* <MenuItem value={'video/mp4'} primaryText="Video (.mp4 / .mov)"/> */}
                        </SelectField> :
                        <TextField
                          key={linkField.prop}
                          style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px' }}
                          inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                          underlineShow={false}
                          onChange={({ target: { value } }) => setState({
                            [linkField.prop]: value,
                            fileTypeError: false,
                            fileTypeChecked: false,
                            checkingFileType: false,
                          })}
                          value={state[linkField.prop]}
                        />
                    }
                  />
                </div>
              );
            })
          }
          {
            isNotNilOrEmpty(state.url) && contains(state.url, existingUrls) ?
              generateErrorText('duplicateUrlError') : <span/>
          }
        </div>
      }
      subContent={state.fileTypeError ? generateErrorText('fileTypeError') : <span/>}
      hiddenErrorChecking={
        state.checkingFileType ?
          <div style={{ display: 'none' }}>
            <img
              src={state.url}
              onLoad={onFileTypeCheckedSuccess}
              onError={onFileTypeError}
            />
          </div> : <span/>
          // call(cond([
          //   [equals('image/jpeg'), () => {
          //     return (
          //       <div style={{ display: 'none' }}>
          //         <img
          //           src={state.url}
          //           onLoad={onFileTypeCheckedSuccess}
          //           onError={onFileTypeError}
          //         />
          //       </div>
          //     );
          //   }],
          //   // UNCOMMENT ONCE REACT / REACTDOM GETS UPDATED
          //   // [equals('video/mp4'), () => {
          //   //   return (
          //   //     <div style={{ display: 'none' }}>
          //   //       <video onCanPlay={onFileTypeCheckedSuccess}>
          //   //         <source
          //   //           src={state.url}
          //   //           type="video/mp4"
          //   //           onError={onFileTypeError}
          //   //         />
          //   //         Your browser doesn't support this video.
          //   //       </video>
          //   //     </div>
          //   //   );
          //   // }],
          //   [T, () => <div/>],
          // ]), state.fileType) : <span/>
      }
    />
  );
};

FileLink.propTypes = {
  onCancel: PropTypes.func,
  clearState: PropTypes.func,
  state: PropTypes.object,
  submitFile: PropTypes.func,
  setState: PropTypes.func,
  onFileTypeCheckedSuccess: PropTypes.func,
  onFileTypeError: PropTypes.func,
  existingUrls: PropTypes.array,
  generateErrorText: PropTypes.func,
};

export default FileLink;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/external-links/file-link.jsx